import React from "react";
import "./App.css"; // Import your CSS styles
import { Navigate, Route, Routes } from "react-router-dom";
import Home from "./pages/Home/Home";
import Projects from "./pages/Projects/Projects";
import AddressSelection from "./pages/AddressSelection/AddressSelection";
import Cart from "./pages/Cart/Cart";
import ContactUs from "./pages/ContactUs/ContactUs";
import Login from "./pages/Login/Login";
import Payment from "./pages/Payment/Payment";
import ProductDetails from "./pages/ProductDetails/ProductDetails";
import Registration from "./pages/Registration/Registration";
import Search from "./pages/Search/Search";
import Services from "./pages/Services/Services";
import About from "./pages/About/About";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Seller from "./pages/Seller/Seller";
import AdminLogin from "./pages/AdminLogin/AdminLogin";
import AdminProducts from "./pages/AdminProducts/AdminProducts";
import AdminNavbar from "./components/AdminDashboard/AdminNavbar/AdminNavbar";
import AdminSidebar from "./components/AdminDashboard/AdminSidebar/AdminSidebar";
import AdminFeedbacks from "./pages/AdminFeedbacks/AdminFeedbacks";
import AdminCustomers from "./pages/AdminCustomers/AdminCustomers";
import AdminSellers from "./pages/AdminSellers/AdminSellers";
import AdminSubAdmin from "./pages/AdminSubAdmin/AdminSubAdmin";
import AdminDashboard from "./pages/AdminDashboard/AdminDashboard";
import CheckOuts from "./pages/CheckOuts/CheckOuts";
import SellerReports from "./pages/SellerReports/SellerReports";
import SellerHome from "./pages/SellerHome/SellerHome";
import SellerOrders from "./pages/SellerOrders/SellerOrders";

import SellerSales from "./pages/SellerSales/SellerSales";
import SellerProducts from "./pages/SellerProducts/SellerProducts";

import SellerStocks from "./pages/SellerStocks/SellerStocks";
import CustomerProfile from "./pages/CustomerProfile/CustomerProfile";
import SellerNavbar from "./components/Seller/SellerNavbar/SellerNavbar";
import SellerSidebar from "./components/Seller/SellerSidebar/SellerSidebar";
import UserCustomers from "./pages/AdminUsers/UserCustomers";
import UserSellers from "./pages/AdminUsers/UserSellers";
import UserSubAdmin from "./pages/AdminUsers/UserSubAdmin";
import SellerSalesView from "./pages/SellerSalesView/SellerSalesView";
import AddProducts from "./components/SellerProduct/AddProducts";
import Wishlist from "./pages/Wishlist/Wishlist";
import MyOrders from "./pages/MyOrders/MyOrders";
import AdminProductView from "./pages/AdminProductView/AdminProductView";
import CategoryView from "./pages/CategoryView/CategoryView";
import OrderDetails from "./pages/CustomerOrderDetails/OrderDetails";
import SellerView from "./pages/AdminSellerView/SellerView";
import CustomerView from "./pages/AdminCustomerView/CustomerView";
import ProfilePaymentCard from "./components/Profile/ProfilePaymentCard";
import ProfileSidebar from "./components/Profile/ProfileSidebar/ProfileSidebar";
import ProfileAddAddress from "./pages/CustomerProfile/ProfileAddAddress";
import ProfileEditAddress from "./pages/CustomerProfile/ProfileEditProfile";
import ProfileMyOrder from "./pages/CustomerProfile/ProfileMyOrder";
import ProfileNotification from "./pages/CustomerProfile/ProfileNotification";
import ProfileRateUs from "./pages/CustomerProfile/ProfileRateUs";
import ProfileLegalInfo from "./pages/CustomerProfile/ProfileLegalInfo";
import ProfileAbout from "./pages/CustomerProfile/ProfileAbout";

import SellerNotification from "./pages/SellerNotification/SellerNotification";
import AdminNotification from "./pages/AdminNotification/AdminNotification";
import SellerProfile from "./pages/SellerProfile/SellerProfile";
import SellerProduct from "./components/SellerProduct/SellerProduct";
import ProductView from "./components/SellerProduct/ProductView";
import SellerOrder from "./components/SellerOrder/SellerOrder";
import Banner from "./pages/Banner/Banner";
import Reviews from "./pages/Reviews/Reviews";
import Sponsored from "./pages/Sponsored/Sponsored";

import Offers from "./pages/Offers/Offers";
import SellerOrderView from "./components/SellerOrder/SellerOrderView";
import Brands from "./pages/Brands/Brands";
import NearstSuppliers from "./pages/NearestSuppliers/NearstSuppliers";
import AdminReport from "./pages/AdminReport/AdminReport";
import AdminBrands from "./pages/AdminBrands/AdminBrands";
import AdminSellerReg from "./pages/AdminSellerReg/AdminSellerReg";
import AdminCreateSub from "./pages/AdminCreateSubReg/AdminCreateSub";
import ForgetPassword from "./pages/ForgetPassword/ForgetPassword";
import AdminSellerApproval from "./pages/AdminSellerApproval/AdminSellerApproval";
import SellerApprovalView from "./pages/AdminSellerApproval/SellerApprovalView";
import SellerLogin from "./components/Seller/SellerLogin/SellerLogin";
import AdminBannerAproval from "./pages/AdminBannerApproval/AdminBannerAproval";
import BannerApprovalView from "./pages/AdminBannerApproval/BannerApprovalView";
import SellerOffer from "./pages/SellerOffer/SellerOffer";
import SellerStatements from "./pages/SellerStatements/SellerStatements";
import SellerCharges from "./pages/SellerCharges/SellerCharges";
import SellerBrand from "./pages/SellerOfferAndBrand/SellerBrand";
import SellerBanner from "./pages/SellerOfferAndBrand/SellerBanner";
import SellerSponsored from "./pages/SellerOfferAndBrand/SellerSponsored";
import EditSellerBanner from "./pages/SellerOfferAndBrand/EditSellerBanner";
import AddSellerBanner from "./pages/SellerOfferAndBrand/AddSellerBanner";
import SellerBannerView from "./pages/SellerOfferAndBrand/SellerBannerView";
import AddSellerBrand from "./pages/SellerOfferAndBrand/AddSellerBrand";
import EditSellerBrand from "./pages/SellerOfferAndBrand/EditSellerBrand";
import SellerBrandView from "./pages/SellerOfferAndBrand/SellerBrandView";
import ProfileEditProfile from "./pages/CustomerProfile/ProfileEditProfile";
import ProfileView from "./pages/CustomerProfile/ProfileView";
import SponsoredViewAll from "./pages/Sponsored/SponsoredViewAll";
import SellerOfferEdit from "./pages/SellerOffer/SellerOfferEdit";
import SellerOfferView from "./pages/SellerOffer/SellerOfferView";
import SellerOfferAdd from "./pages/SellerOffer/SellerOfferAdd";
import SellerSponsorAdd from "./pages/SellerSponsor/SellerSponsorAdd";
import SellerSponsorView from "./pages/SellerSponsor/SellerSponsorView";
import SellerSponsorEdit from "./pages/SellerSponsor/SellerSponsorEdit";
import EditProduct from "./components/SellerProduct/EditProduct";
import LoginOTP from "./pages/Login/LoginOTP";
import RegistrationSucessful from "./pages/Registration/RegistrationSucessful";
import PublicLayout from "./Layout/PublicLayout";
import { use } from "react";
import { useAuth } from "./context/AuthContext";
import SellerLayout from "./Layout/SellerLayout";
import ProtectedRoute from "./Protected/ProtectedRoute";
import AdminLayout from "./Layout/AdminLayout";
import UnAuthorized from "./Protected/UnAuthorized";
import NotAllowed from "./Protected/NotAllowed";
import AddEditOrganization from "./pages/CustomerProfile/AddEditOrganization";
import SellerRegistration from "./pages/SellerRegistration/SellerRegistration";
import ChangePassword from "./pages/CustomerProfile/ChangePassword";
import AdminOrders from "./pages/AdminOrders/AdminOrders";
import AdminOrder from "./components/AdminOrders/AdminOrder";
import AdminOrderView from "./components/AdminOrders/AdminOrderView";
import AdminSponsor from "./components/AdminSponsor/AdminSponsor";
import AdminSponsors from "./pages/AdminSponsor/AdminSponsors";
import AdminSponsorView from "./components/AdminSponsor/AdminSponsorView";
import Coupons from "./pages/CustomerProfile/Coupons";
import AgentCode from "./pages/CustomerProfile/AgentCode";
import AdminCreateCategory from "./pages/AdminCreateCategory/AdminCreateCategory";
import SellerLoginOTP from "./pages/Login/SellerLoginOTP";
import DeleteAccount from "./pages/CustomerProfile/DeleteAccount";
import Settings from "./pages/CustomerProfile/Settings";
import AdminSales from "./pages/AdminSales/AdminSales";
import AdminSalesReport from "./pages/AdminReport/AdminSalesReport";
import AdminDeliveryReport from "./pages/AdminReport/AdminDeliveryReport";
import AdminOrderReport from "./pages/AdminReport/AdminOrderReport";
import AdminSalesView from "./pages/AdminSales/AdminSalesView";
import SellerRegistrationSucessfull from "./pages/SellerRegistration/SellerRegistrationSucessfull";
import AdminOfferApproval from "./pages/AdminOffer/AdminOfferApproval";
import AdminOfferApprovalView from "./pages/AdminOffer/AdminOfferApprovalView";
import AdminCustomerAllocation from "./pages/AdminAllocation/AdminCustomerAllocation";
import AdminSellerAllocation from "./pages/AdminAllocation/AdminSellerAllocation";
import AdminCreateItem from "./pages/AdminCreateItem/AdminCreateItem";
import AdminRevenueandIncome from "./pages/AdminRevenueAndIncome/AdminRevenueandIncome";
import AdminRevenue from "./pages/AdminRevenueAndIncome/AdminRevenue";
import AdminBannerIncome from "./pages/AdminRevenueAndIncome/AdminBannerIncome";
import AdminOfferIncome from "./pages/AdminRevenueAndIncome/AdminOfferIncome";
import AdminSponsorIncome from "./pages/AdminRevenueAndIncome/AdminSponsorIncome";
import AdminStatements from "./pages/AdminStatements/AdminStatements";

import AdminProductFeedback from "./pages/AdminFeedbacks/AdminProductFeedback";
import ListCategory from "./pages/AdminCreateCategory/ListCategory";
import EditCategory from "./pages/AdminCreateCategory/EditCategory";
import CreateSubCategory from "./pages/AdminSubCategory/CreateSubCategory";
import EditSubCategory from "./pages/AdminSubCategory/EditSubCategory";
import ListSubCategory from "./pages/AdminSubCategory/ListSubCategory";
import SubAdminReport from "./pages/SubAdminReport/SubAdminReport";
import SubAdminLayout from "./Layout/SubAdminLayout";
import SubAdminDashboard from "./pages/SubAdminDashboard/SubAdminDashboard";
import SubAdminSalesReport from "./pages/SubAdminReport/SubAdminSalesReport";
import SubAdminDeliveryReport from "./pages/SubAdminReport/SubAdminDeliveryReport";
import SubAdminOrderReport from "./pages/SubAdminReport/SubAdminOrderReport";
import SubAdminSales from "./pages/SubAdminSales/SubAdminSales";
import SubAdminSalesView from "./pages/SubAdminSales/SubAdminSalesView";
import SubAdminNotification from "./pages/SubAdminNotification/SubAdminNotification";
import AdminBrandView from "./pages/AdminBrands/AdminBrandView";
import SubAdminSeller from "./pages/SubAdminSeller/SubAdminSeller";
import SubAdminSellerView from "./pages/SubAdminSeller/SubAdminSellerView";
import SubAdminCustomer from "./pages/SubAdminCustomer/SubAdminCustomer";
import SubAdminCustomerView from "./pages/SubAdminCustomer/SubAdminCustomerView";
import SubAdminProfile from "./pages/SubAdminProfile/SubAdminProfile";
import SubAdminOrders from "./pages/SubAdminOrders/SubAdminOrders";
import AdminBrand from "./pages/AdminCreateBrand/AdminBrand";
import AdminAddBrand from "./pages/AdminCreateBrand/AdminAddBrand";
import AdminEditBrand from "./pages/AdminCreateBrand/AdminEditBrand";
import AdminBrandsView from "./pages/AdminCreateBrand/AdminBrandsView";
import AdminAppFeedbackSeller from "./pages/AdminFeedbacks/AdminAppFeedbackSeller";
import AdminAppFeedbackCustomer from "./pages/AdminFeedbacks/AdminAppFeedbackCustomer";
import AdminOfferBank from "./pages/AdminOffer/AdminOfferBank";
import AdminOfferEMI from "./pages/AdminOffer/AdminOfferEMI";
import AdminOfferReward from "./pages/AdminOffer/AdminOfferReward";
import AdminOfferAdvertisement from "./pages/AdminOffer/AdminOfferAdvertisement";
import AdminBanner from "./pages/AdminCreateBanner/AdminBanner";
import AdminAddBanner from "./pages/AdminCreateBanner/AdminAddBanner";
import AdminEditBanner from "./pages/AdminCreateBanner/AdminEditBanner";
import AdminBannerView from "./pages/AdminCreateBanner/AdminBannerView";
import SellerRejected from "./Protected/SellerRejected";
import SellerWaiting from "./Protected/SellerWaiting";
import AdminPackages from "./pages/AdminPackages/AdminBannerPackage";
import AdminBannerPackage from "./pages/AdminPackages/AdminBannerPackage";
import AdminSponsorPackage from "./pages/AdminPackages/AdminSponsorPackage";
import AdminSpecialOfrer from "./pages/AdminPackages/AdminSpecialOfrer";
import { ToastContainer } from "react-toastify";
import AddSponsorPackage from "./pages/AdminPackages/AddSponsorPackage";
import AddSpecialPackage from "./pages/AdminPackages/AddSpecialPackage";
import AddBannerPackage from "./pages/AdminPackages/AddBannerPackage";
import AdminLoginOTP from "./pages/Login/AdminLoginOTP";
import AdminProfile from "./pages/AdminProfile/AdminProfile";
import AdminCreateUnit from "./pages/AdminCreateUnit/AdminCreateUnit";
import TermsAndConditions from "./pages/PublicPages/TermsAndConditions";
import PrivacyPolicy from "./pages/PublicPages/PrivacyPolicy";
import OrderCommission from "./pages/AdminRevenueAndIncome/OrderCommission";
import AdminSponsorRevenue from "./pages/AdminRevenueAndIncome/AdminSponsorRevenue";
import AdminSellerPayout from "./pages/AdminRevenueAndIncome/AdminSellerPayout";
import SubadminPayouts from "./pages/AdminRevenueAndIncome/SubadminPayout";
import SubadminPayoutDetails from "./pages/AdminRevenueAndIncome/SubadminPayoutDetails";

import SellerRevenue from "./pages/SellerRevenue/SellerRevenue";
import SellerTransactionHistory from "./pages/SellerRevenue/SellerTransactionHistory";
import SubAdminRevenue from "./pages/SubAdminRevenue/SubAdminRevenue";
import TransactionHistory from "./pages/SubAdminRevenue/TransactionHistory";

const App = () => {
  const { user, isAuthenticated } = useAuth();
  console.log(" Authentiated user", user);
  console.log(" Authentiated isAuthenticated", isAuthenticated);

  return (
    <div>
      <ToastContainer position="top-center" autoClose={3000} />
      <Routes>
        {/* Public routes with layout */}
        <Route
          path="/"
          element={
            user?.user_type === "admin" ? (
              <Navigate to="/admin" replace />
            ) : user?.user_type === "seller" ? (
              user?.is_approved === "Approved" ? (
                <Navigate to="/seller" replace />
              ) : user?.is_approved === "Pending" ? (
                <Navigate to="/seller/pending" replace />
              ) : user?.is_approved === "Rejected" ? (
                <Navigate to="/seller/rejected" replace />
              ) : (
                <Navigate to="/login/email" replace />
              )
            ) : user?.user_type === "subadmin" ? (
              <Navigate to="/subadmin" replace />
            ) : (
              <PublicLayout />
            )
          }
        >
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="projects" element={<Projects />} />
          <Route path="search" element={<Search />} />
          <Route path="services" element={<Services />} />
          <Route path="contact-us" element={<ContactUs />} />
          
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route
            path="product-details/:productId"
            element={<ProductDetails />}
          />
          <Route
            path="product-details/reviews/:productId"
            element={<Reviews />}
          />
          <Route path="category/:categoryId/" element={<CategoryView />} />
          <Route path="brands" element={<Brands />} />
          <Route path="brands/:id" element={<Brands />} />
          <Route path="nearest_suppliers/:id" element={<NearstSuppliers />} />
          <Route path="offers/:offer_id" element={<Offers />} />
          <Route path="orders/:order_number/:id" element={<OrderDetails />} />
          <Route path="banner/:offerId" element={<Banner />} />
          <Route path="sponsored/:sponsorId" element={<Sponsored />} />
          <Route path="sponsored/all" element={<SponsoredViewAll />} />
        </Route>

        {/* </Route> */}
        {/* user routes with layout */}
        <Route element={<ProtectedRoute allowedRoles={["customer"]} />}>
          <Route path="/" element={<PublicLayout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="projects" element={<Projects />} />
            <Route path="search" element={<Search />} />
            <Route path="services" element={<Services />} />
            <Route path="contact-us" element={<ContactUs />} />
            <Route path="cart" element={<Cart />} />
            <Route path="wishlist" element={<Wishlist />} />
            <Route path="myorders" element={<MyOrders />} />
            <Route path="address-selection" element={<AddressSelection />} />
            <Route path="checkouts" element={<Payment />} />
            <Route
              path="product-details/:productId"
              element={<ProductDetails />}
            />
            <Route
              path="/product-details/reviews/:productId"
              element={<Reviews />}
            />
            <Route path="category/:categoryId/" element={<CategoryView />} />
            <Route path="brands" element={<Brands />} />
            <Route path="brands/:id" element={<Brands />} />
            <Route path="nearest_suppliers/:id" element={<NearstSuppliers />} />
            <Route path="offers/:offer_id" element={<Offers />} />
            {/* <Route path="category/:categoryId/" element={<CategoryView />} /> */}
            <Route path="orders/:order_number/:id" element={<OrderDetails />} />
            <Route path="banner/:offerId" element={<Banner />} />
            <Route path="sponsored/:sponsorId" element={<Sponsored />} />
            <Route path="sponsored/all" element={<SponsoredViewAll />} />
            <Route path="offers/" element={<Offers />} />
            {/* customer profile  */}
          </Route>
          <Route
            path="profile/"
            element={<CustomerProfile isProfilePage={true} />}
          >
            <Route path="view" element={<ProfileView />} />
            <Route path="payments" element={<ProfilePaymentCard />} />
            <Route path="add_address" element={<ProfileAddAddress />} />
            <Route path="edit_profile" element={<ProfileEditProfile />} />
            <Route path="notification" element={<ProfileNotification />} />
            <Route path="rate_us" element={<ProfileRateUs />} />
            <Route path="legal_info" element={<ProfileLegalInfo />} />
            <Route
              path="add_edit_organization"
              element={<AddEditOrganization />}
            />
            <Route path="change_password" element={<ChangePassword />} />
            <Route path="coupons" element={<Coupons />} />
            <Route path="agent_code" element={<AgentCode />} />
            <Route path="settings" element={<Settings />} />
            <Route path="settings/delete-account" element={<DeleteAccount />} />
          </Route>
          {/* <Route path="seller/register" element={<SellerRegistration />} /> */}
        </Route>

        {/* seller routes with Layout */}

        <Route element={<ProtectedRoute allowedRoles={["seller"]} />}>
          <Route path="/seller" element={<SellerLayout />}>
            <Route index element={<SellerHome />} />
            <Route path="sales/overview" element={<SellerSales />} />
            <Route path="sales/sales_report" element={<SellerReports />} />
            <Route path="products" element={<SellerProducts />}>
              <Route path="add_product" element={<AddProducts />} />
              <Route path="edit/:id" element={<EditProduct />} />
              <Route path="view/:id" element={<ProductView />} />
              <Route path="view_products" element={<SellerProduct />} />
            </Route>
            <Route path="stocks" element={<SellerStocks />} />
            <Route path="orders" element={<SellerOrders />}>
              <Route path="view_orders" element={<SellerOrder />} />
              <Route path="view_order/:id" element={<SellerOrderView />} />
            </Route>
            <Route path="sales/view_sales" element={<SellerSalesView />} />
            <Route path="notification" element={<SellerNotification />} />

            <Route path="offer/brand" element={<SellerBrand />} />
            <Route path="offer/banner" element={<SellerBanner />} />
            <Route path="offer_brand/sponsored" element={<SellerSponsored />} />
            <Route
              path="offer_brand/sponsor/Edit/:sponsorId"
              element={<SellerSponsorEdit />}
            />
            <Route
              path="offer_brand/sponsor/View/:sponsorId"
              element={<SellerSponsorView />}
            />

            <Route
              path="offer_brand/sponsor/Add"
              element={<SellerSponsorAdd />}
            />

            <Route path="offer_brand/Offer" element={<SellerOffer />} />
            <Route
              path="offer_brand/Offer/Edit/:offerId"
              element={<SellerOfferEdit />}
            />
            <Route
              path="offer_brand/Offer/View/:offerId"
              element={<SellerOfferView />}
            />

            <Route path="offer_brand/Offer/Add" element={<SellerOfferAdd />} />

            <Route path="charges" element={<SellerCharges />} />
            {/* new page */}
            <Route path="revenue" element={<SellerRevenue />} />
            <Route path="revenue/transactions" element={<SellerTransactionHistory />} />
            <Route path="statements" element={<SellerStatements />} />

            <Route
              path="offer/banner/edit/:bannerId"
              element={<EditSellerBanner />}
            />
            <Route path="offerbrand/addbanner" element={<AddSellerBanner />} />
            <Route
              path="offer/banner/view/:id"
              element={<SellerBannerView />}
            />

            <Route path="offer/brand/addbrand" element={<AddSellerBrand />} />
            <Route
              path="offer/brand/edit/:brandId"
              element={<EditSellerBrand />}
            />
            <Route path="offer/brand/view/:id" element={<SellerBrandView />} />
            <Route path="settings" element={<Settings />} />
            <Route path="settings/delete-account" element={<DeleteAccount />} />
            <Route path="rate_us" element={<ProfileRateUs />} />
          </Route>
          {/* seller  Without layout */}
          <Route path="seller/profile" element={<SellerProfile />} />
        </Route>

        {/*admin Routes with Layout */}

        <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="feedbacks/app/all" element={<AdminFeedbacks />} />
            <Route
              path="feedbacks/app/seller"
              element={<AdminAppFeedbackSeller />}
            />
            <Route
              path="feedbacks/app/customer"
              element={<AdminAppFeedbackCustomer />}
            />
            <Route
              path="feedbacks/product"
              element={<AdminProductFeedback />}
            />

            <Route path="create/brand" element={<AdminBrand />} />
            <Route path="add/brand" element={<AdminAddBrand />} />
            <Route path="edit/brand/:brandId" element={<AdminEditBrand />} />
            <Route path="create/brand/view/:id" element={<AdminBrandsView />} />
            <Route path="create/banner" element={<AdminBanner />} />
            <Route path="add/banner" element={<AdminAddBanner />} />
            <Route path="edit/banner/:bannerId" element={<AdminEditBanner />} />
            <Route path="banner/view/:id" element={<AdminBannerView />} />
            <Route path="sellers" element={<AdminSellers />} />
            <Route path="subadmins" element={<AdminSubAdmin />} />
            <Route path="customers" element={<AdminCustomers />} />
            <Route path="approval/products" element={<AdminProducts />} />
            <Route path="users/customers" element={<UserCustomers />} />
            <Route path="users/sellers" element={<UserSellers />} />
            <Route path="users/subadmin" element={<UserSubAdmin />} />
            <Route path="sellers/view/:companyId" element={<SellerView />} />
            <Route
              path="customers/view/:productId"
              element={<CustomerView />}
            />

            <Route
              path="product-details/:productId"
              element={<AdminProductView />}
            />
            <Route path="notifications" element={<AdminNotification />} />
            <Route path="sales" element={<AdminSales />} />
            <Route path="sales/view" element={<AdminSalesView />} />
            <Route path="report/overall" element={<AdminReport />} />
            <Route path="report/sales" element={<AdminSalesReport />} />
            <Route path="report/delivery" element={<AdminDeliveryReport />} />
            <Route path="report/orders" element={<AdminOrderReport />} />

            <Route path="approval/offer" element={<AdminOfferApproval />} />
            <Route
              path="approval/offer/view/:offerId"
              element={<AdminOfferApprovalView />}
            />

            <Route path="create/seller" element={<AdminSellerReg />} />
            <Route path="create/subadmin" element={<AdminCreateSub />} />
            <Route path="create/item" element={<AdminCreateItem />} />
            <Route path="create/unit" element={<AdminCreateUnit />} />
            <Route
              path="/admin/create/category"
              element={<AdminCreateCategory />}
            />
            <Route path="/admin/list/category" element={<ListCategory />} />
            <Route
              path="/admin/edit/category/:catId"
              element={<EditCategory />}
            />
            <Route
              path="/admin/create/subcategory"
              element={<CreateSubCategory />}
            />
            <Route
              path="/admin/list/subcategory"
              element={<ListSubCategory />}
            />
            <Route
              path="/admin/edit/subcategory/:catId"
              element={<EditSubCategory />}
            />
            <Route path="approval/seller" element={<AdminSellerApproval />} />
            <Route
              path="approval/seller/view/:company_id"
              element={<SellerApprovalView />}
            />
            <Route path="approval/banner" element={<AdminBannerAproval />} />
            <Route
              path="approval/banner/view/:id"
              element={<BannerApprovalView />}
            />
            <Route path="approval/brands" element={<AdminBrands />} />
            <Route
              path="approval/brands/view/:id"
              element={<AdminBrandView />}
            />
            <Route path="approval" element={<AdminSponsors />}>
              <Route path="sponsor" element={<AdminSponsor />} />
              <Route
                path="sponsor/View/:sponsorId"
                element={<AdminSponsorView />}
              />
            </Route>
            <Route path="orders" element={<AdminOrders />}>
              <Route path="view_orders" element={<AdminOrder />} />
              <Route path="view_order/:id" element={<AdminOrderView />} />
            </Route>
            <Route
              path="allocation/customer"
              element={<AdminCustomerAllocation />}
            />
            <Route
              path="allocation/seller"
              element={<AdminSellerAllocation />}
            />
            <Route path="notification" element={<AdminNotification />} />
            <Route path="offers/bank" element={<AdminOfferBank />} />
            <Route path="offers/emi" element={<AdminOfferEMI />} />
            <Route path="offers/rewards" element={<AdminOfferReward />} />
            <Route
              path="offers/advertisement"
              element={<AdminOfferAdvertisement />}
            />

            <Route
              path="revenueandincome"
              element={<AdminRevenueandIncome />}
            />
            <Route path="packages/banner" element={<AdminBannerPackage />} />
            <Route path="packages/banner/add" element={<AddBannerPackage />} />
            <Route
              path="packages/banner/edit/:id"
              element={<AddBannerPackage Edit={true} />}
            />
            <Route
              path="packages/specialoffer"
              element={<AdminSpecialOfrer />}
            />
            <Route
              path="packages/specialoffer/add"
              element={<AddSpecialPackage />}
            />
            <Route
              path="packages/specialoffer/edit/:id"
              element={<AddSpecialPackage Edit={true} />}
            />
            <Route path="packages/sponsor" element={<AdminSponsorPackage />} />
            <Route
              path="packages/sponsor/add"
              element={<AddSponsorPackage />}
            />
            <Route
              path="packages/sponsor/Edit/:id"
              element={<AddSponsorPackage Edit={true} />}
            />
            {/* <Route path="revenue" element={<AdminRevenue />} /> */}

            <Route path="revenue" element={<AdminRevenue />} />
            <Route path="ordercommission" element={<OrderCommission />} />
            <Route path="promotionrevenue" element={<AdminSponsorRevenue />} />
            <Route path="sellerpayout" element={<AdminSellerPayout />} />
            <Route path="subadminpayout" element={<SubadminPayouts />} />
            <Route
              path="subadminpayout/:id"
              element={<SubadminPayoutDetails />}
            />


            {/* <Route path="bannerincome" element={<AdminBannerIncome />} />
            <Route path="offerincome" element={<AdminOfferIncome />} />
            <Route path="sponsorincome" element={<AdminSponsorIncome />} /> */}
            <Route path="statements" element={<AdminStatements />} />
          </Route>
          <Route path="admin/profile" element={<AdminProfile />} />
        </Route>

        {/*sub admin Routes with Layout */}

        <Route element={<ProtectedRoute allowedRoles={["subadmin"]} />}>
          <Route path="/subadmin" element={<SubAdminLayout />}>
            <Route index element={<SubAdminDashboard />} />
            <Route path="sales" element={<SubAdminSales />} />
            <Route path="sales/view" element={<SubAdminSalesView />} />
            <Route path="report/overall" element={<SubAdminReport />} />
            <Route path="report/sales" element={<SubAdminSalesReport />} />
            <Route path="sellers" element={<SubAdminSeller />} />
            <Route path="sellers/view/:Id" element={<SubAdminSellerView />} />
            <Route path="customers" element={<SubAdminCustomer />} />
            <Route
              path="customers/view/:customerId"
              element={<SubAdminCustomerView />}
            />
            <Route path="profile" element={<SubAdminProfile />} />
            <Route
              path="report/delivery"
              element={<SubAdminDeliveryReport />}
            />
            <Route path="orders" element={<AdminOrders />}>
              <Route path="view_orders" element={<AdminOrder />} />
              <Route path="view_order/:id" element={<AdminOrderView />} />
            </Route>
            <Route path="report/orders" element={<SubAdminOrderReport />} />
            <Route path="notifications" element={<SubAdminNotification />} />
            <Route path="revenue" element={<SubAdminRevenue />} />
            <Route path="revenue/transactions" element={<TransactionHistory />} />
          </Route>
        </Route>

        {/* Standalone pages */}
        <Route path="/seller/info" element={<Seller />} />
        <Route path="/login/email" element={<LoginOTP />} />
        <Route path="/seller/login/email" element={<SellerLoginOTP />} />
        <Route path="/admin/login/email" element={<AdminLoginOTP />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/seller/register" element={<SellerRegistration />} />
        <Route path="/seller/login" element={<SellerLogin />} />
        <Route path="/seller/pending" element={<SellerWaiting />} />
        <Route path="/seller/rejected" element={<SellerRejected />} />

        <Route
          path="/registration/successful"
          element={<RegistrationSucessful />}
        />
        <Route
          path="/seller/registration/successful"
          element={<SellerRegistrationSucessfull />}
        />
        <Route path="/forgetpassword" element={<ForgetPassword />} />
        {/* Unauthorized Page */}
        <Route path="/unauthorized" element={<UnAuthorized />} />

        <Route path="*" element={<NotAllowed />} />
      </Routes>
    </div>
  );
};

export default App;
